export enum OrderStep {
    CHOOSE_ACCOUNT = 'CHOOSE_ACCOUNT',
    CHOOSE_SERVICE_LOCATION = 'CHOOSE_SERVICE_LOCATION',
    HOUSING_SELECT = 'HOUSING_SELECT',
    PRODUCTS_DETAILS = 'PRODUCTS_DETAILS',
    SUMMARY = 'SUMMARY',
    SUCCESS = 'SUCCESS',
}
